






























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import dayjs from 'dayjs';
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class employeeCommission extends Vue {
  fmoney =fmoney;
  timeValue = dayjs(new Date()).format("YYYY-MM");
  /**登陆信息 */
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    jobNumberOrName: "",
    startDate: dayjs(new Date()).format("YYYY-MM"),
    endDate: dayjs(new Date()).format("YYYY-MM"),
    sort: null,
    skip: 0,
    count: 10,
  };
  exloading = false;
  async mounted() {
    await this.getlist();
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetAccountReportList(this.searchValue);
    this.listData = result.items;
    this.total = result.totalCount;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = dayjs(new Date()).format("YYYY-MM");
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      jobNumberOrName: "",
      startDate: dayjs(new Date()).format("YYYY-MM"),
      endDate: dayjs(new Date()).format("YYYY-MM"),
      sort: null,
      skip: 0,
      count: 10,
    };
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  /**时间改变 */
  timeChange(val) {
    console.log('val',val);
    if (val) {
      this.searchValue.startDate = dayjs(val).format("YYYY-MM");
      this.searchValue.endDate = dayjs(val).format("YYYY-MM");
    } else {
      this.searchValue.startDate = "";
      this.searchValue.endDate = "";
    }
  }
  /**统计合计 */
    getSummaries(param) {
      const { columns, data } = param;
      const sums:any = [];
      let sumTotal = this.jsHj();

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = `合计`;
              return;
          }
          sums[index] = sumTotal[column.property];
      });

      return sums;
    }
    jsHj() {
      let form = {
          totalRecharge: '',
          salesTotal: '',
          returnTotal: '',
          commissionTotal: '',
      },
      arr = this.listData;
      if (arr.length > 0) {
          form = {
              totalRecharge: fmoney(arr.map(v=>v.totalRecharge).reduce((n,m)=>Number((Number(n)+Number(m)))),2),
              salesTotal:fmoney(arr.map(v=>v.salesTotal).reduce((n,m)=>Number((Number(n)+Number(m)))),2),
              returnTotal: fmoney(arr.map(v=>v.returnTotal).reduce((n,m)=>Number((Number(n)+Number(m)))),2),
              commissionTotal:fmoney(arr.map(v=>v.commissionTotal).reduce((n,m)=>Number((Number(n)+Number(m)))),2),
          };
      }
      return form;
    }
    export_table() {
      try {
      this.exloading = true;
      Public.GetAccountOverviewReport(Object.assign({},this.searchValue,{
        skip:0,
        count:-1
      })).then((res) => {
        var fileName = "员工提成报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/employeeCommission/index.vue